import { createContext } from 'react';
import { ComponentController } from '../core/controller';

/**
 * App Context Interface
 *
 * Provides access to the main controller throughout the component tree.
 * The controller handles its own state management (ready, error, etc.).
 */
export interface AppContextValue {
  /** The main component controller instance */
  controller: ComponentController | null;
}

/**
 * App Context
 *
 * React context for providing controller access to child components.
 */
const AppContext = createContext<AppContextValue | undefined>(undefined);

export { AppContext };
